<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Sample" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.identifier"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <add-on-select
      :selectedAddOns="add_ons"
      :addOns="addOns"
      @onAddOnSelect="onAddOnSelect"
    ></add-on-select>
  </div>
</template>

<script>
import AddOnSelect from "../../AddOnSelect";

export default {
  name: "GeneralSampleFormGroup",
  components: { AddOnSelect },
  props: ["sample", "addOns", "index"],
  data() {
    return {
      form: {
        test_package_sample_id: null,
        identifier: null
      },
      add_ons: []
    };
  },
  methods: {
    onSampleChange() {
      let params = JSON.parse(JSON.stringify(this.form));
      params.add_ons = JSON.parse(JSON.stringify(this.add_ons));
      this.$emit("onSampleChange", {
        sample: params,
        index: this.index
      });
    },
    onAddOnSelect(addOns) {
      if (addOns && addOns.length) {
        this.add_ons = addOns;
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.onSampleChange();
      },
      deep: true
    },
    add_ons: {
      handler() {
        this.onSampleChange();
      },
      deep: true
    }
  },
  created() {
    let sample = JSON.parse(JSON.stringify(this.sample));
    if (sample && sample.test_package_sample_id) {
      this.form.test_package_sample_id = sample.test_package_sample_id;
      this.form.identifier = sample.identifier;
      this.add_ons = sample.add_ons || [];
    }
  }
};
</script>
